 $(document).ready(function(){
  $('#product-slider').slick({
    slidesToShow: 4,       
    slidesToScroll: 1,    
    rows: 3,               
    infinite: true,        
    autoplay: false,       
    arrows: true,         
    dots: false,           
    swipe: true,           
    draggable: true,      
    prevArrow: '<button type="button" class="prevz-arrow"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25 25"><path style="fill:#ea02d4" d="M24 12.001H2.914l5.294-5.295-.707-.707L1 12.501l6.5 6.5.707-.707-5.293-5.293H24v-1z" data-name="Left"/></svg></button>',
    nextArrow: '<button type="button" class="nextz-arrow"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25 25"><path style="fill:#ea02d4" d="m17.5 5.999-.707.707 5.293 5.293H1v1h21.086l-5.294 5.295.707.707L24 12.499l-6.5-6.5z" data-name="Right"/></svg></button>',
    responsive: [
      {
        breakpoint: 768,   
        settings: {
          slidesToShow: 3, 
          rows: 3,         
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 480,   
        settings: {
          slidesToShow: 2, 
          rows: 2,
          slidesToScroll: 1
        }
      }
    ]
  });
});